import Breadcrumbs from "components/general/Breadcrumbs";
import Container from "components/general/Container";
import PageHeader from "components/general/Headers/PageHeader";
import PageLoader from "components/general/PageLoader";
import ScrollContainer from "components/general/ScrollContainer";
import Section from "components/general/Section";
import Pagination from "components/navigation/Pagination";
import ServiceOrderHeader from "components/serviceOrders/ServiceOrderHeader";
import ServiceOrderTable from "components/serviceOrders/ServiceOrderTable";
import { Box, Button, H1, HStack, ParagraphSmall } from "components/ui";
import { Link } from "expo-router";
import { Calendar } from "lucide-react-native";
import React from "react";
import { ActivityIndicator } from "react-native";
import { useGetServiceOrderQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";

interface Props {
	equipmentId?: number;
	isMainScreen?: boolean;
}

export function ServiceOrderScreen({ equipmentId, isMainScreen = true }: Props) {
	const isMobile = useIsMobile();
	const [pageNumber, setPageNumber] = React.useState(1);
	const [equipmentIdCollection, setEquipmentIdCollection] = React.useState<number[]>([]);

	const { data, isLoading, isFetching } = useGetServiceOrderQuery({
		pageNumber,
		equipmentIdCollection: equipmentId ? [equipmentId] : equipmentIdCollection,
	});

	if (isLoading) {
		return (
			<Box minHeight={"$full"} justifyContent="center" borderRadius={16}>
				<ActivityIndicator size={"large"} style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }, { translateY: 25 }] }} />
			</Box>
		);
	}

	if (isMainScreen) {
		return (
			<ScrollContainer>
				<Container>
					<PageHeader
						title="Service Orders"
						component={
							<HStack alignItems="center" mb={24} marginLeft={isMobile ? 0 : "auto"} gap={16}>
								<Box flex={isMobile ? 1 : undefined}>
									<Link href={`/equipment/my-equipment/book-a-service`} asChild>
										<Button width={"$full"} borderRadius={12} gap={4} borderColor="transparent" variant="outline" bg="$primarylight">
											<Calendar color="#ffffff" />
											<ParagraphSmall
												sx={{
													color: "$basicwhite",
												}}
											>
												Book A Service
											</ParagraphSmall>
										</Button>
									</Link>
								</Box>
							</HStack>
						}
					/>
					{/* <Box pb={20}>
						<Breadcrumbs  />
					</Box>
					<HStack flexDirection={isMobile ? "column" : "row"}>
						<H1
							sx={{
								paddingBottom: 16,
								"@md": {
									paddingBottom: 20,
									lineHeight: 48,
								},
							}}
						>
							Service Orders
						</H1>

						<HStack alignItems="center" mb={24} marginLeft={isMobile ? 0 : "auto"} gap={16}>
							<Box flex={isMobile ? 1 : undefined}>
								<Link href={`/equipment/my-equipment/book-a-service`}>
									<Button width={"$full"} borderRadius={12} gap={4} borderColor="transparent" variant="outline" bg="$primarylight">
										<Calendar color="#ffffff" />
										<ParagraphSmall
											sx={{
												color: "$basicwhite",
											}}
										>
											Book A Service
										</ParagraphSmall>
									</Button>
								</Link>
							</Box>

						</HStack>
					</HStack> */}

					{/* <Box zIndex={8} paddingHorizontal={isMobile ? 16 : 87} paddingVertical={isMobile ? 12 : 27} bg="$neutral25" borderRadius={16}> */}
					<Section>
						{isFetching && <ActivityIndicator size="large" style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }, { translateY: 25 }] }} />}
						{data != null && <ServiceOrderTable dataList={data.list} />}
						<Box justifyContent="center" marginTop={30} alignItems="center">
							<Pagination pageCount={data?.metaData?.pageCount} pageNumber={data?.metaData?.pageNumber} onChangePage={setPageNumber} />
						</Box>
					</Section>
					{/* </Box> */}
				</Container>
			</ScrollContainer>
		);
	}

	return (
		<Box gap={24}>
			<ServiceOrderHeader isMainScreen={false} />
			<Box zIndex={8} paddingHorizontal={isMobile ? 16 : 0} borderRadius={12} paddingVertical={isMobile ? 12 : 24} bg="$basicwhite">
				{isFetching && <ActivityIndicator size="large" style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }, { translateY: 25 }] }} />}
				{data != null && <ServiceOrderTable dataList={data.list} />}
				<Box justifyContent="center" marginTop={30} alignItems="center">
					<Pagination pageCount={data?.metaData?.pageCount} pageNumber={data?.metaData?.pageNumber} onChangePage={setPageNumber} />
				</Box>
			</Box>
		</Box>
	);
}
